import { commonResx } from "../resxDist/commonResx";

export class UnsavedChangesNotifier {
    private _activeOperationsCount = 0;

    private constructor() {
        window.addEventListener("beforeunload", this.onWindowBeforeUnload);
    }

    trackPromise(promise: JQuery.Promise<any>) {
        this._activeOperationsCount++;
        promise.always(this._onPromiseCompleted);
        return promise;
    }

    _onPromiseCompleted = () => this._activeOperationsCount--;

    private onWindowBeforeUnload = (event: BeforeUnloadEvent) => {
        if (this._activeOperationsCount > 0) {
            event.preventDefault();
            event.returnValue = commonResx.WindowUnload_UnsavedChanges;
            return event.returnValue;
        }
    };

    private destroy() {
        window.removeEventListener("beforeunload", this.onWindowBeforeUnload);
    }

    private static _instance: UnsavedChangesNotifier;
    static get instance() {
        return this._instance || (this._instance = new UnsavedChangesNotifier());
    }

    static resetForTests() {
        if (this._instance) {
            this._instance.destroy();
            this._instance = null;
        }
    }
}
